<template>
    <div class="app">
        <nav-menu v-if="!hideNav" :search="search">
            <template #search>
                <slot name="search"></slot>
            </template>
            
            <slot name="nav"></slot>

            <template #nav-end="slotProps">
                <slot name="nav-end" v-bind="slotProps"></slot>
            </template>
        </nav-menu>

        <div class="app-body" scroll-region>
            <flash-messages></flash-messages>
            <validation-errors></validation-errors>

            <slot></slot>
        </div>

        <!-- Slot for modals used with Teleport -->
        <!-- If not working; use isMounted bool in component where modal is used -->
        <div id="modals"></div>
    </div>
</template>

<script>
import FlashMessages from "./FlashMessages.vue"
import ValidationErrors from "@/shared/ValidationErrors.vue"
import NavMenu from "./NavMenu.vue"

export default {
    components: {
        FlashMessages,
        NavMenu,
        ValidationErrors,
    },
    props: {
        hideNav: Boolean,
        search: String,
    },
}
</script>
